<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M9.82577 19.0171V16.5637C9.82576 15.9397 10.3345 15.4327 10.9648 15.4285H13.2737C13.907 15.4285 14.4204 15.9367 14.4204 16.5637V16.5637V19.0247C14.4203 19.5546 14.8474 19.9876 15.3824 20H16.9217C18.4561 20 19.7 18.7685 19.7 17.2495V17.2495V10.2703C19.6918 9.67266 19.4084 9.11148 18.9304 8.74643L13.6662 4.54824C12.7439 3.81725 11.433 3.81725 10.5107 4.54824L5.26962 8.75405C4.78981 9.11762 4.50591 9.67973 4.5 10.2779V17.2495C4.5 18.7685 5.7439 20 7.27833 20H8.81757C9.36588 20 9.81038 19.56 9.81038 19.0171V19.0171"
      stroke="#83868A"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
